import React from 'react'
import logo from "../../assets/images/logo/Medical.png";
const PharmaLogo = () => {
    return <img src={logo} alt="Bloqcube" width="100"/>;
}

export default PharmaLogo
